import { isAndroid, isIos } from 'utils/platform';
import { NativeFunction } from 'types/native';

export function runNativeFunction<T>(
  key: NativeFunction,
  params?: T,
  iosHandler = 'scriptHandler'
): void {
  if (isAndroid() && functionExistsForNativeAndroidInterface(key)) {
    if (params) window.NativeAndroidInterface[key]?.(params);
    else window.NativeAndroidInterface[key]?.();
  }
  if (isIos() && functionExistsForWebkit(iosHandler)) {
    window.webkit.messageHandlers[iosHandler].postMessage(key);
  }
}

export function functionExistsForNativeAndroidInterface(
  functionName: NativeFunction
): boolean {
  if (window.NativeAndroidInterface) {
    if (typeof window.NativeAndroidInterface[functionName] === 'function') {
      return true;
    }
  }
  return false;
}

export function functionExistsForWebkit(handler = 'scriptHandler'): boolean {
  if (window.webkit?.messageHandlers?.[handler]?.postMessage) {
    if (
      typeof window.webkit.messageHandlers[handler].postMessage === 'function'
    ) {
      return true;
    }
  }
  return false;
}
